import { EntityType } from "../../rl-common/shared/shared/entity-type.enum";

export class SectionsChangesEvent {
    type : 'ADD' | 'DELETE' | 'UPDATE';
    entityType : EntityType; // can be removed in full ANGULAR (use instance of instead)
    data : any;

    constructor(type : 'ADD' | 'DELETE' | 'UPDATE', entityType : EntityType, data : any){
        this.type = type;
        this.entityType = entityType;
        this.data = data;
    }
}
